import React, { ChangeEvent, useCallback } from 'react';
import { Grid, Typography } from '@mui/material';
import { CheckboxOne } from '../../../../../components/CheckboxOne/CheckboxOne.component';
import { ToleranceRangeRow } from '../ToleranceRange.types';

export const ToleranceLabels: React.FC<{
  value: ToleranceRangeRow;
  type: keyof ToleranceRangeRow;
  handleValueChange: (type: keyof ToleranceRangeRow, value: number | boolean | null, id: string | number) => void;
  validation?: (row: ToleranceRangeRow) => boolean;
}> = ({ value, type, handleValueChange, validation }) => {
  const onCheckboxChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      handleValueChange('isActive', event.target.checked, value.id);
      if (validation) {
        validation(value);
      }
    },
    [handleValueChange, type, value.id, value.isActive],
  );

  const marginLeft = value.fieldType === 'examTaskGroup' ? 0 : value.fieldType === 'task' ? 3 : 6;
  const marginRight = value.fieldType === 'examTaskGroup' ? 0 : value.fieldType === 'task' ? -3 : -6;
  const isMainLabel = marginLeft === 0;
  const isTaskLabel = marginLeft === 3;

  return (
    <Grid
      container
      wrap={'nowrap'}
      sx={{ marginLeft: marginLeft, marginRight: marginRight, alignItems: 'center', width: '280px', minHeight: 59 }}
      area-label={`zakres tolerancji`}
    >
      {!value.hasSingleItemChildren ? (
        <CheckboxOne
          area-label={`${value.isActive ? 'Wyłącz' : 'Włącz'} zakres tolerancji`}
          inputProps={{
            'aria-label': `${value.isActive ? 'Wyłącz' : 'Włącz'} zakres tolerancji`,
          }}
          checked={value.isActive}
          onChange={onCheckboxChange}
        />
      ) : (
        <span style={{ marginRight: 38 }}></span>
      )}
      <Typography area-label={`nazwa zakres tolerancji`} sx={{ fontSize: 14, fontWeight: 400, marginTop: 0.2 }}>
        {isMainLabel || isTaskLabel ? (
          <>
            {value[type]}
            <span>{` [${value.scores.length > 0 ? value.scores[0] : ''} pkt]`}</span>
          </>
        ) : (
          <div style={{ display: 'inline-flex', flexDirection: 'column' }}>
            {value[type]}
            {value.scores && value.scores.length > 0 && <span>{`[ ${value.scores.join(' | ')} ] pkt`}</span>}
          </div>
        )}
      </Typography>
    </Grid>
  );
};
